<template>
  <div class="trial-bar trial-bar--discount bg-v2-blue-400 text-white">
    <div class="d-flex align-items-center">
      <span class="btn trial-bar__btn bg-white">TRIAL</span>
      <span v-if="trialDaysLeft >= 0" class="trial-bar__remainder">{{ $tc('subscription.days_left', trialDaysLeft, { value: trialDaysLeft }) }}</span>
    </div>
    <span class="trial-bar__description" v-html="$tc('subscription.trial_experiment_discount', authStore.promoDiscountDaysLeft, { days: authStore.promoDiscountDaysLeft })"/>
    <s-button-v2 size="mini" theme="base" @click="openPaymentModal">
      {{ $t('subscription.actions.explore_pricing') }}
    </s-button-v2>
  </div>
</template>
<script setup>
  import { computed } from 'vue';
  import { useSubscriptionStore } from '@/stores/subscription';
  import { useAuthStore } from '@/stores/auth.ts';

  const subscriptionStore = useSubscriptionStore();
  const authStore = useAuthStore();

  const trialDaysLeft = computed(() => authStore.user?.permissions?.user_subscription?.days_left);

  function openPaymentModal() {
    subscriptionStore.setModalVisible(true);
  }
</script>
